import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1031913436679691';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const parent = document.head || document.getElementsByTagName('script')[0]?.parentNode || document.body;
      parent?.appendChild(script);
      window.fbq('init', META_PIXEL_ID);
    }
    window.fbq?.('track', 'PageView');
  }, []);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Toaster position="top-center" richColors data-id="element-1" />
      <noscript data-id="element-2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" />
      </noscript>
      <main className="flex-grow" data-id="element-4">
        <Hero data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <FailedAttempts data-id="element-7" />
        <UniqueMechanism data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <ForWhom data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <Proof data-id="element-12" />
        <FAQ data-id="element-13" />
        <OfferSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}